import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "i-layer"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "col-12 mb-4"
};
const _hoisted_5 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_6 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_7 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_8 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_9 = {
  class: "col-12 mb-4"
};
const _hoisted_10 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_11 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_12 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_13 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_14 = {
  class: "col-12 mb-4"
};
const _hoisted_15 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_16 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_17 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_18 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_19 = {
  key: 0,
  class: "col-12 mb-4"
};
const _hoisted_20 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_21 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_22 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_23 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_24 = {
  class: "col-12 mb-3 mt-3"
};
const _hoisted_25 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2 justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_26 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_27 = {
  class: "d-flex align-items-center"
};
const _hoisted_28 = {
  key: 0,
  class: "err-tip"
};
const _hoisted_29 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_30 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2 justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_31 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_32 = {
  class: "d-flex align-items-center"
};
const _hoisted_33 = {
  key: 0,
  class: "err-tip"
};
const _hoisted_34 = {
  key: 1,
  class: "mt-4"
};
const _hoisted_35 = {
  key: 0,
  class: "horizontal-dividing-line mt-4"
};
const _hoisted_36 = {
  key: 1,
  class: "col-12 mt-3"
};
const _hoisted_37 = {
  class: "mt-3 mb-3"
};
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-24"
}, "Transfer Node Ownership", -1);
const _hoisted_39 = {
  class: "mt-1 fsi-14 tip-content"
};
const _hoisted_40 = {
  key: 2,
  class: "mt-3 w-100"
};
const _hoisted_41 = {
  key: 3,
  class: "col-12 mt-3"
};
const _hoisted_42 = {
  class: "mt-3 mb-3"
};
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-24"
}, "Accept Node Ownership", -1);
const _hoisted_44 = {
  class: "mt-1 fsi-14 tip-content"
};
const _hoisted_45 = {
  key: 2,
  class: "col-12 mt-4"
};
const _hoisted_46 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_SingerV2 = _resolveComponent("SingerV2");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('subpool.poolAddress')), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString($props.poolAddress), 1), _createElementVNode("div", {
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[0] || (_cache[0] = $event => $options.copy($props.poolAddress)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('common.Node')) + " ID", 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, "f0" + _toDisplayString($props.nodeId), 1), _createElementVNode("div", {
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[1] || (_cache[1] = $event => $options.copy(`f0${$props.nodeId}`)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('Onboarding.Original Owner')) + " (f0 " + _toDisplayString(_ctx.$t('Onboarding.Address')) + ")", 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString($data.originalOwnerF0), 1), _createElementVNode("div", {
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[2] || (_cache[2] = $event => $options.copy($data.originalOwnerF0)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])])]), !$data.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('Onboarding.Original Owner')), 1)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString($data.originalOwner), 1), _createElementVNode("div", {
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[3] || (_cache[3] = $event => $options.copy($data.originalOwner)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('subpool.new owner')), 1)]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_input, {
    size: "large",
    class: _normalizeClass($data.newPoolAddressErr ? 'err-input' : ''),
    onInput: _cache[4] || (_cache[4] = $event => {
      $data.newPoolAddressErr = false;
      this.newOwner = this.newOwner.trim();
    }),
    style: {
      "height": "50px"
    },
    type: "textarea",
    resize: "none",
    onKeyup: _withKeys($options.affirm, ["enter"]),
    disabled: $data.newOwnerIsOk,
    modelValue: $data.newOwner,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.newOwner = $event),
    placeholder: _ctx.$t('subpool.new owner tip')
  }, null, 8, ["class", "onKeyup", "disabled", "modelValue", "placeholder"])]), $data.newPoolAddressErr ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($data.newPoolAddressErrStr), 1)) : _createCommentVNode("", true)]), $data.newOwnerIsOk ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('subpool.new owner')) + " (f0 " + _toDisplayString(_ctx.$t('Onboarding.Address')) + ")", 1)]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_input, {
    size: "large",
    style: {
      "height": "50px"
    },
    disabled: true,
    modelValue: $data.newOwnerF0,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.newOwnerF0 = $event),
    placeholder: _ctx.$t('subpool.new owner tip')
  }, null, 8, ["modelValue", "placeholder"])]), $data.newPoolAddressErr ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString($data.newPoolAddressErrStr), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$data.newOwnerIsOk ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_el_button, {
    loading: $data.loading.checkAddress,
    disabled: $data.loading.initPoolLoading || $data.loading.checkIsStepTowLoading || $data.loading.initOriginalOwnerLoading || $data.newOwner !== '' && $data.newOwnerIsOk,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.affirm
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])])) : _createCommentVNode("", true)]), !$data.resultOk ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.newOwnerIsOk && $data.active !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_35)) : _createCommentVNode("", true), $data.newOwnerIsOk && $data.active === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('subpool.Initiate a proposal using the source Owner')), 1)]), _createVNode(_component_SingerV2, {
    ref: "singer",
    singerType: "approval",
    btnProposal: "Send Proposal",
    "contract-method": $data.one.contractMethod,
    contractParams: $data.one.contractParams,
    "is-call-evm": false,
    "contract-a-b-i": $data.one.ABI,
    "from-address": $data.one.fromAddress,
    "to-eth-address": $data.one.toEthAddress,
    "to-f0-address": $data.one.toF0Address,
    onNext: _cache[7] || (_cache[7] = $event => $data.active = 2)
  }, null, 8, ["contract-method", "contractParams", "contract-a-b-i", "from-address", "to-eth-address", "to-f0-address"])])])) : _createCommentVNode("", true), $data.active === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_el_button, {
    onClick: $options.nextSign,
    class: "btn btn-primary w-100 i-button"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Next')), 1)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), $data.newOwnerIsOk && $data.active === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('subpool.Confirm the proposal with the new Owner')), 1)]), _createVNode(_component_SingerV2, {
    ref: "singer2",
    singerType: "approval",
    btnProposal: "Send Proposal",
    "contract-method": $data.tow.contractMethod,
    contractParams: $data.tow.contractParams,
    "is-call-evm": false,
    "contract-a-b-i": $data.tow.ABI,
    "from-address": $data.tow.fromAddress,
    "to-eth-address": $data.tow.toEthAddress,
    "to-f0-address": $data.tow.toF0Address,
    onNext: $options.signOk
  }, null, 8, ["contract-method", "contractParams", "contract-a-b-i", "from-address", "to-eth-address", "to-f0-address", "onNext"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.resultOk ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('subpool.changeOwnerOk'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])])), [[_directive_loading, $data.loading.initPoolLoading || $data.loading.checkIsStepTowLoading || $data.loading.initOriginalOwnerLoading]])]);
}